import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
var cn = classNames.bind(style);

/**
 * Компонент-обертка, добавляющий скругленные границы
 */

var Card = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? true : _ref$bordered,
    withHover = _ref.withHover,
    className = _ref.className,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Card' : _ref$testName;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(className, 'card', {
      'card--bordered': bordered,
      'card--with-hover': withHover
    }),
    "data-component": testName
  }, children);
});
Card.displayName = Card.name;
export { Card };